export default __webpack_public_path__ + "static/1791-151ae5f3c80622a7b6fcb44440d19b9b.gif";